import { getLocale } from "../runtime";

const sv_blog = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Blogg`
};

const blog = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_blog(inputs)
	return "blog";
};

export { blog as "blog" };